import { useState } from "react";

interface QnA {
  q: string;
  a: string;
}

const faqs: QnA[] = [
  {
    q: "하수구가 막혔는데 물이 조금씩은 내려가요. 바로 업체를 불러야 하나요?",
    a: "물이 조금씩 내려간다고 해서 막힘이 해결된 것은 아닙니다.<br/> 배관 내부에 이물질이나 기름때, 슬러지 등이 쌓여 배수 속도가 느려진 상태일 수 있습니다.<br/> 방치하면 어느 순간 배수가 완전히 막히거나 역류가 발생할 수 있어 배수가 평소보다 느려졌다면 미리 점검받는 것이 좋습니다.",
  },
  {
    q: "하수구 막힘은 어떤 방법으로 뚫어주시나요?",
    a: "막힘 원인과 배관 상태에 따라 적합한 장비를 선택해 작업합니다.<br/> 일반적인 막힘은 관통기나 스프링 장비를 사용할 수 있으며, 기름이나 찌꺼기가 심하게 쌓인 경우에는 고압세척을 진행하기도 합니다.<br/> 필요할 경우 내시경을 이용해 배관 내부를 직접 확인한 후 작업 방향을 결정합니다.",
  },
  {
    q: "하수구에서 악취가 올라오는데 막힌 것도 아닌 것 같아요. 왜 그런가요?",
    a: "하수구 악취는 배관 내부에 쌓인 오염물이나 기름때, 슬러지 등이 원인이 될 수 있으며 트랩이나 배수구 주변의 문제로 발생하기도 합니다.<br/> 단순히 방향제를 사용해 냄새를 가리는 것보다 악취가 발생하는 원인을 확인하고 배관 내부를 청소하는 것이 도움이 됩니다.",
  },
  {
    q: "하수구가 자주 막히는데 한 번 뚫으면 다시 막히지 않나요?",
    a: "단순히 막힌 부분만 뚫는 작업은 시간이 지나 다시 막힐 가능성이 있습니다.<br/> 특히 배관 내부에 기름때나 이물질이 넓게 쌓여 있는 경우에는 고압세척 등을 통해 배관 내부를 깨끗하게 청소하는 것이 좋습니다.<br/> 반복적으로 막힌다면 단순 막힘이 아닌 배관 자체의 문제인지 함께 확인해야 합니다.",
  },
  {
    q: "하수구 막힘이나 역류 작업 비용은 얼마인가요?",
    a: "하수구 작업 비용은 막힌 위치와 원인, 배관의 크기와 길이, 필요한 장비 및 작업 난이도에 따라 달라질 수 있습니다.<br/> 간단한 배수구 막힘과 고압세척이 필요한 현장의 비용은 차이가 크기 때문에 현장 상태를 확인한 후 정확한 작업 방법과 비용을 안내하는 것이 가장 정확합니다.",
  },
];

const DnD = () => {
  const [openSet, setOpenSet] = useState<number[]>([]);

  const toggle = (i: number) => {
    setOpenSet((prev) =>
      prev.includes(i) ? prev.filter((v) => v !== i) : [...prev, i],
    );
  };

  return (
    <div className="relative w-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-24 xl:py-28">
      <div className="mx-auto max-w-[1000px]">
        {/* 상단 타이틀 */}
        <div className="text-center tracking-tighter" data-aos="fade-up">
          <h3 className=" font-medium text-xl md:text-2xl">
            <span className="text-primary">자주 물어보는 질문</span> Q&amp;A
          </h3>
          <h3 className="gbold text-secondary">
            전화로&nbsp;문의주시면 보다&nbsp;자세히&nbsp;설명드리겠습니다
          </h3>
        </div>

        {/* 아코디언 */}
        <div className="mt-10 flex flex-col gap-4">
          {faqs.map((faq, i) => {
            const open = openSet.includes(i);
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border bg-white transition-colors ${
                  open ? "border-primary" : "border-[#cdd6f5]"
                }`}
              >
                {/* 질문 */}
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                  className="flex w-full items-center gap-3 p-5 text-left"
                >
                  <span className="shrink-0 text-primary md:text-lg lg:text-2xl">
                    Q.
                  </span>
                  <span className="flex-1 text-secondary md:text-lg lg:text-2xl">
                    {faq.q}
                  </span>
                  <span
                    aria-hidden="true"
                    className={`shrink-0 text-sm lg:text-2xl text-secondary transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>

                {/* 답변 (부드럽게 펼침/접힘) */}
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    open ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="flex gap-3 px-5 lg:px-8 pb-5">
                    <span className="shrink-0 text-primary md:text-base">
                      A.
                    </span>
                    <p
                      dangerouslySetInnerHTML={{ __html: faq.a }}
                      className="whitespace-pre-line text-sm leading-relaxed text-secondary md:text-base"
                    ></p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DnD;
